import type { CollectionConfig, ClientCollectionConfig, Field } from 'payload'
import { mapCollectionFields, removeEmptyParentFields, flattenCollectionFieldClient } from '@utils/fields'
import { isObject, mergeObjects, flattenObjectArrayByKeyRecursively } from '@utils/objects'
/**
 * Get text label from a Collection.
 * In general, we just use StaticLabels, so it's pretty safe to return strings everywhere.
 *
 * @param collection
 * @returns
 */
export function getCollectionSingular(collection: CollectionConfig | ClientCollectionConfig): string {
  if (typeof collection?.labels?.singular === 'string') {
    return collection.labels.singular;
  }

  return `${collection.slug}s`;
}

/**
 * Get text label from a Collection.
 * In general, we just use StaticLabels, so it's pretty safe to return strings everywhere.
 *
 * @param collection
 * @returns
 */
export function getCollectionPlural(collection: CollectionConfig | ClientCollectionConfig): string {
  if (typeof collection?.labels?.plural === 'string') {
    return collection.labels.plural;
  }

  return collection.slug;
}

/**
 * Make paginated fields a array of docs (recursively)
 *
 * @param item
 * @returns
 */
export function flattenPaginatedDocs(item: PayloadEntity): PayloadEntity {
  for (const key in item) {
    if (isObject(item[key]) && ('docs' in item[key])) {
      item[key] = item[key].docs.map((v: PayloadEntity) => flattenPaginatedDocs(v));
    }
  }

  return item;
}

/**
 * Like a mergeObjects, but keeps all fields and merge by "name"
 *
 * @param configFields
 * @param fields
 * @returns
 */
export function mergeConfigFields(defaultFields: CollectionConfig['fields'], newFields: CollectionConfig['fields'], keepDefaultTree: boolean = false): CollectionConfig['fields'] {
  const fieldsA = [ ...(keepDefaultTree ? defaultFields : newFields) ];
  let fieldsB = [ ...(keepDefaultTree ? newFields : defaultFields) ];

  const newfields = mapCollectionFields(fieldsA, (fieldA) => {
    if (! fieldA.name) {
      return fieldA;
    }

    let found = false;
    fieldsB = mapCollectionFields(fieldsB, (fieldB) => {
      if (! fieldB.name || fieldB.name !== fieldA.name || found) {
        return fieldB;
      }

      // For first found: merge and remove from 'fieldsB'
      found = true;
      fieldA = keepDefaultTree ? mergeObjects(fieldA, fieldB) : mergeObjects(fieldB, fieldA);

      return null;
    });

    return fieldA;
  });

  return removeEmptyParentFields([...newfields, ...fieldsB]);
}
